import { Modal, Popover } from "antd";
import { Header } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { purgeStoredState } from "redux-persist";
import styled from "styled-components";

import { ReactComponent as ICON_AVATAR } from "@assets/svgs/ICON_AVATAR.svg";
import { ReactComponent as ICON_DOT_MENU } from "@assets/svgs/ICON_DOT_MENU.svg";
import { ReactComponent as ICON_EDIT_PROFILE } from "@assets/svgs/ICON_EDIT_PROFILE.svg";
import { ReactComponent as ICON_LOGOUT } from "@assets/svgs/ICON_LOGOUT.svg";
import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { Text } from "@components/Text";
import { PERSIST_CONFIG } from "@redux/store";
import { COLOR_DARK, COLOR_WHITE } from "@static/COLORS";
import { LOCATION_TO_BREAD_CRUMB } from "@static/LOCATION_TO_BREAD_CRUMB";
import { MODAL_SIZE } from "@static/SIZE";
import { fetchAPI } from "@utils/https/fetchAPI";
import {
  clearLocalStorageAuth,
  clearLocalStorageProfile,
  getLocalStorageUserProfile,
} from "@utils/localStorage";
import { useShowConfirmation } from "@utils/useShowConfirmation";

import { FormEditProfile } from "./FormEditProfile";

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

const SectionBreadCrumb = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
`;

const SectionUser = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Line = styled.div`
  width: 1px;
  background-color: ${COLOR_WHITE};
  height: 20px;
`;

const SectionActionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 6px;
  box-sizing: border-box;
`;

const GroupActionDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: start;
  align-items: flex-start;
  cursor: pointer;
`;

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showConfirmation = useShowConfirmation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const pathname = _.get(location, ["pathname"]);
  const replacePathname = _.chain(pathname).split("/").last().value();

  const userProfile = getLocalStorageUserProfile();

  const breadCrumbData = _.get(LOCATION_TO_BREAD_CRUMB, [replacePathname]);

  const onHandleLogout = async () => {
    await fetchAPI({
      method: "get",
      path: "/auth/logout",
      isAuth: true,
    });
    await purgeStoredState(PERSIST_CONFIG);
    clearLocalStorageProfile();
    clearLocalStorageAuth();
    navigate("/");
  };

  //

  return (
    <Header style={{ padding: "16px 32px", background: COLOR_DARK }}>
      <SectionHeader>
        <SectionBreadCrumb>
          {_.chain(breadCrumbData)
            .map((item, index) => {
              const isLastIndex = _.size(breadCrumbData) - 1 === index;
              return (
                <Text
                  key={index}
                  fontSize="22px"
                  color={COLOR_WHITE}
                  fontWeight={isLastIndex ? "600" : "300"}
                >
                  {item}
                </Text>
              );
            })
            .value()}
        </SectionBreadCrumb>
        <SectionUser>
          <Icon width={"32px"} height={"32px"}>
            <ICON_AVATAR />
          </Icon>
          {_.get(userProfile, ["categoryCustomer"]) && (
            <Text fontSize="14px" color={COLOR_WHITE} fontWeight="600">
              {_.get(userProfile, ["categoryCustomer", "customer_name"])}
            </Text>
          )}
          <Line />

          <Text fontSize="14px" color={COLOR_WHITE} fontWeight="600">
            {_.get(userProfile, ["username"])}
          </Text>
          <Line />

          <Popover
            placement="bottomRight"
            trigger="click"
            open={isPopoverVisible}
            onOpenChange={(visible) => setIsPopoverVisible(visible)}
            content={
              <SectionActionDetails>
                <GroupActionDetails
                  onClick={() => {
                    setIsPopoverVisible(false);
                    setIsModalVisible(true);
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ICON_EDIT_PROFILE
                      width={14}
                      height={14}
                      fill={COLOR_DARK}
                    />
                  </div>

                  <Text fontSize="14px" color={COLOR_DARK} fontWeight="600">
                    Edit Profile
                  </Text>
                </GroupActionDetails>

                <GroupActionDetails
                  onClick={() =>
                    showConfirmation({ onConfirm: onHandleLogout })
                  }
                >
                  <ICON_LOGOUT width={20} height={20} fill={COLOR_DARK} />
                  <Text fontSize="14px" color={COLOR_DARK} fontWeight="600">
                    Logout
                  </Text>
                </GroupActionDetails>
              </SectionActionDetails>
            }
          >
            <ICON_DOT_MENU
              style={{ cursor: "pointer" }}
              width={20}
              height={20}
              fill={COLOR_WHITE}
            />
          </Popover>
        </SectionUser>
      </SectionHeader>

      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`Edit Profile`}
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
      >
        <FormEditProfile
          setIsModalVisible={setIsModalVisible}
          userProfile={userProfile}
        />
      </Modal>
    </Header>
  );
};
